<template>
  <q-page class="q-pa-md bg-grey-2">
    <q-card class="shadow-2 rounded-borders">
      <q-card-section class="bg-primary text-white row items-center justify-between q-py-md">
        <div class="text-h6 text-weight-bold row items-center">
          <q-icon :name="$route.params.id ? 'edit' : 'add_circle'" class="q-mr-sm" size="sm" />
          {{ $route.params.id ? 'Editar Plan' : 'Nuevo Plan' }}
        </div>
      </q-card-section>

      <q-card-section class="q-pa-md">
        <q-form @submit.prevent="Guardar" class="q-gutter-y-md">
          <q-input
            v-model="NuevaData.nombre"
            label="Nombre del Plan *"
            outlined
            dense
            :rules="[val => !!val || 'El nombre es requerido']"
          />

          <div class="row q-col-gutter-md">
            <div class="col-12 col-sm-6">
              <q-select
                v-model="NuevaData.tipo"
                :options="tipos"
                option-value="estado"
                option-label="descripcion"
                emit-value
                map-options
                label="Tipo de Plan *"
                outlined
                dense
              />
            </div>
            <div class="col-12 col-sm-6">
              <q-input
                v-model.number="NuevaData.precio"
                type="number"
                label="Precio (S/) *"
                outlined
                dense
                :rules="[val => !!val || 'El precio es requerido']"
              />
            </div>
          </div>

          <div class="row q-col-gutter-md">
            <div class="col-12 col-sm-6">
              <q-input
                v-model.number="NuevaData.nconsultas"
                type="number"
                label="Cantidad de Consultas *"
                outlined
                dense
                :rules="[val => !!val || 'La cantidad es requerida']"
              />
            </div>
            <div class="col-12 col-sm-6">
              <q-input
                v-model="NuevaData.descripcion"
                label="Descripción"
                outlined
                dense
              />
            </div>
          </div>

          <div class="row justify-end q-pt-md">
            <q-btn
              type="submit"
              color="primary"
              label="Guardar Plan"
              icon="save"
              unelevated
              :loading="isLoading"
              :disable="EstadoBoton"
              class="text-weight-bold"
            />
          </div>
        </q-form>
      </q-card-section>
    </q-card>
  </q-page>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      isLoading: false,
      EstadoBoton: false,
      tipos: [
        { estado: "mensual", descripcion: "Mensual" },
        { estado: "anual", descripcion: "Anual" },
      ],
      NuevaData: {
        idplan: "",
        nombre: "",
        tipo: "mensual",
        precio: "",
        nconsultas: "",
        descripcion: "",
      },
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.CargarDatos();
    }
  },
  methods: {
    CargarDatos() {
      let me = this;
      axios({
        method: "post",
        url: "ApiWeb/PlanId.php",
        data: { idplan: me.$route.params.id },
      })
        .then((response) => {
          if (response.data && response.data.data) {
            me.NuevaData = response.data.data;
          }
        })
        .catch((error) => console.error(error));
    },
    Guardar() {
      const url = this.$route.params.id ? "ApiWeb/PlanUpdate.php" : "ApiWeb/PlanInsertar.php";
      let me = this;
      this.isLoading = true;
      this.EstadoBoton = true;

      axios({
        method: "post",
        url: url,
        data: me.NuevaData,
      })
        .then((response) => {
          if (response.data.estado == "ERROR") {
            this.notificar(response.data.mensaje, "warning");
          } else {
            this.notificar(response.data.mensaje || "Plan guardado exitosamente", "positive");
            this.Limpiar();
            this.$router.push("/aveo/Plan/ListaPlanes");
          }
        })
        .catch((error) => console.error(error))
        .finally(() => {
          this.isLoading = false;
          this.EstadoBoton = false;
        });
    },
    notificar(msg, color) {
      if (this.$q && this.$q.notify) {
        this.$q.notify({
          message: msg,
          color: color,
          position: "top-right",
          timeout: 3000
        });
      } else {
        alert(msg);
      }
    },
    Limpiar() {
      this.NuevaData = {
        idplan: "",
        nombre: "",
        tipo: "mensual",
        precio: "",
        nconsultas: "",
        descripcion: "",
      };
    },
  },
};
</script>
